import { ApiError, statusMessage } from "../../api-errors.ts";
import { errorCopy } from "../../error-copy.ts";
import { t } from "../../i18n/i18n.ts";
import { uncoveredRefusal } from "../../models/model-labels.ts";

/** A refused project change in catalogue words, including unknown refusals. */
export function projectRefusal(error: Error, context: "member" | "project" = "project"): string {
  if (error instanceof ApiError && error.code === "pending_approval") {
    return error.message;
  }
  const uncovered = uncoveredRefusal(error);
  if (uncovered) {
    return uncovered;
  }
  if (error instanceof ApiError && error.code === "project_frozen") {
    return t("settings.members.refused.frozen");
  }
  if (context === "member" && error instanceof ApiError && error.status === 404) {
    return t("settings.members.refused.notFound");
  }
  if (error instanceof ApiError && error.explained) {
    return error.message;
  }
  const known = errorCopy(error instanceof ApiError ? error.code : undefined, error.message);
  if (known) {
    return known;
  }
  return error instanceof ApiError ? statusMessage(error.status) : t("errors.unexpected");
}
